import { render, staticRenderFns } from "./IconEmojiAngry.vue?vue&type=template&id=48e9087b&"
import script from "./IconEmojiAngry.vue?vue&type=script&lang=js&"
export * from "./IconEmojiAngry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports